import React from 'react'

import { withActions } from '../../../WithActions';
import MediaRecordingActions from "../../../actions/MediaRecordingActions";

import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

import AudioView from '../audioView/AudioView';
import Devices from '../Devices';
import RecordButton from '../RecordButton';
import Controls from './controls/Controls';
import RecorderSources from '../recorderSources/RecorderSources';
import CountdownDialog from '../dialogs/CountdownDialog';

import AnimateText from '../utils/AnimateText';

import { ReactMediaRecorder } from "react-media-recorder";
import { uploadVideo } from '../../../services/s3Connector';
import { Redirect } from 'react-router-dom';
import IViewQueryParams from '../../../recorderView/ui/IViewQueryParams';
import TagManager from 'react-gtm-module';

interface Props {
  queryParams: IViewQueryParams;
  actions: MediaRecordingActions;
  handleChangeSourceSelected: (index: number) => void,
  handleChangeAudioAllowed: (value: boolean) => void,
  handleChangeVideoAllowed: (value: boolean) => void,
  sourceSelected: number,
  isAudioAllowed: boolean,
  isVideoAllowed: boolean
}

interface State {
  enabledScreen: boolean,
  enabledAudio: boolean,
  cancelSession: boolean,
  redirect: boolean,
  videoId: string | null,
  loading: boolean
}

const tagManagerArgs = {
  gtmId: 'GTM-NV67WG6'
}

TagManager.initialize(tagManagerArgs)

const onClickRecord = () => {
  (window as any).dataLayer.push({ 'event': 'screen-recording-start-record' });
};

class ScreenView extends React.Component<Props, State> {

  timeoutRedirect: any = null

  constructor(props: Props) {
    super(props);

    this.state = {
      enabledScreen: true,
      enabledAudio: true,
      cancelSession: false,
      redirect: false,
      videoId: '',
      loading: false,
    };
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (this.state.redirect) {
      this.timeoutRedirect = setTimeout(() => {
        this.setState({ loading: false })
      }, 250);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutRedirect)
  }

  handleOnStartRecord = (startRecording: () => void) => {
    this.setState(() => {
      return { enabledScreen: true, cancelSession: false }
    });
    onClickRecord();
    return this.props.actions.onStartRecord(startRecording)
  };

  handleOnMuteAudio = (muteAudio: () => void) => {
    this.setState(() => { return { enabledAudio: false } });
    return this.props.actions.onMuteAudio(muteAudio)
  };

  handleOnUnMuteAudio = (unMuteAudio: () => void) => {
    this.setState(() => { return { enabledAudio: true } });
    return this.props.actions.onUnMuteAudio(unMuteAudio)
  };

  handleCancelSession = () => {
    this.setState(() => { return { cancelSession: true } });
  };

  handleCloseCountdownDialog = () => {
    this.setState(() => { return { cancelSession: true } });
  };

  handleRedirect = () => {
    this.timeoutRedirect = setTimeout(() => {
      this.setState({ redirect: true })
    }, 100)
  }

  handleSaveVideo = async (blobUrl: string, blob: Blob): Promise<void> => {
    try {
      if (!this.state.cancelSession) {
        this.setState(() => { return { loading: true } });
        const response = await uploadVideo(blob);
        this.setState(() => { return { videoId: response } });
        if (this.props.queryParams.stopRedirect) {
          window.parent.postMessage(['videoId', response], '*');
          return
        }
        this.handleRedirect()
      }
    }
    catch (error) {
      console.log('fail to save video: ', error)
    }
  }

  render() {
    const { enabledScreen, enabledAudio, redirect, loading, videoId } = this.state

    if (loading) {
      return (<Box
        border='5px solid #ffffff'
        bgcolor='#ffffff'
        py={8}
      >
        <AnimateText
          status={redirect ? 'redirecting' : 'preparing your video'}
          icon={<CircularProgress
            size={20}
            thickness={4}
            value={100}
          />}
        />
      </Box>)
    }

    if (!this.props.queryParams.stopRedirect && redirect) {
      return <Redirect push to={`/view?videoId=${videoId}&edit=true`} />;
    }

    if (this.props.sourceSelected === 0) {
      return (
        <div>
          <ReactMediaRecorder
            screen={enabledScreen}
            audio={enabledAudio}
            blobPropertyBag={{ type: 'video/mp4' }}
/*             mediaRecorderOptions={{
              mimeType: 'video/mp4; codecs="avc1.424028, mp4a.40.2"'
            }} */
            onStop={this.handleSaveVideo}
            render={({ status, startRecording, pauseRecording, stopRecording, resumeRecording, mediaBlobUrl, muteAudio, unMuteAudio, previewStream, clearBlobUrl }) => (
              <div>
                {status !== 'recording' &&
                  <div>
                    <RecorderSources
                      actions={this.props.actions}
                      handleChangeSourceSelected={this.props.handleChangeSourceSelected}
                      sourceSelected={this.props.sourceSelected}
                      recorderStatus={status}
                    />
                   <AudioView
                      enabledAudio={enabledAudio}
                    />
                    <Devices
                      handleMuteAudio={() => this.handleOnMuteAudio(muteAudio)}
                      handleUnMuteAudio={() => this.handleOnUnMuteAudio(unMuteAudio)}
                      setSelectedCamMenuItem={1}
                      handleChangeSourceSelected={this.props.handleChangeSourceSelected}
                      handleChangeAudioAllowed={this.props.handleChangeAudioAllowed}
                      handleChangeVideoAllowed={this.props.handleChangeVideoAllowed}
                    />
                    <RecordButton
                      handleStartRecord={() => { this.handleOnStartRecord(startRecording) }}
                      sourceSelected={this.props.sourceSelected}
                      isAudioAllowed={this.props.isAudioAllowed}
                      isVideoAllowed={this.props.isVideoAllowed}
                    />
                  </div>
                }
                <Box
                  border='5px solid #ffffff'
                  bgcolor='#ffffff'
                >
                  <AnimateText
                    status={status}
                    icon={<FiberManualRecordIcon
                      color="error"
                      fontSize="small"
                    />}
                  />
                </Box>
                <Controls
                  status={status}
                  sourceSelected={this.props.sourceSelected}
                  handlePlayRecord={startRecording}
                  handlePauseRecord={pauseRecording}
                  handleResumeRecord={resumeRecording}
                  handleStopRecord={stopRecording}
                  handleCancelSession={this.handleCancelSession}
                />
                <CountdownDialog
                  handlePlayRecord={startRecording}
                  handleStopRecord={stopRecording}
                  status={status}
                  onClose={this.handleCloseCountdownDialog}
                />
              </div>
            )}
          />
        </div>);
    } else {
      return null
    }
  }

}

export default withActions(ScreenView);